import { RefObject, useEffect, useRef } from 'react';

export const useKeyPress = (callback: () => void, key: string, preventDefault = true): void => {
  useEffect(() => {
    const eventListener = (event: KeyboardEvent): void => {
      if (event.key === key) {
        if (preventDefault) event.preventDefault();
        callback();
      }
    };

    document.addEventListener('keydown', eventListener);

    return (): void => document.removeEventListener('keydown', eventListener);
  });
};

export const useKeydownRef = (callback: (e: KeyboardEvent) => void): RefObject<HTMLDivElement> => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const eventRef = ref?.current;
    if (eventRef) {
      eventRef.addEventListener('keydown', callback);
    }
    return (): void => {
      if (eventRef) {
        eventRef.removeEventListener('keydown', callback);
      }
    };
  }, [ref, callback]);

  return ref;
};
